// Environment
const env = process.env.VUE_APP_ENV || 'development'
console.log('Build environment:', env)
const envDevelopment = env === 'development'
const envStaging = env === 'staging'
const envProduction = env === 'production'
// Package JSON data
const { version } = require('./package.json') || {}
const { lang, hosting, gtm_container_id, twitterHandle, text_data } = require('./data.json') || {}
// Hosting links
const { institution_url, frontend, backend } = hosting || {}
const institutionUrl = institution_url || 'https://www.revolutionviewing.com'
const frontendUrl = (frontend && frontend[env]) || '/'
console.log('frontendUrl', frontendUrl)
const backendUrl = backend && (envProduction ? backend.production :  backend.staging)
if (!backendUrl) { console.error(`hosting -> backend is missing`) }
console.log('backendUrl', backendUrl)
// Text data
const { institution_name, project_reference, meta_description, meta_keywords } = text_data || {}
const institutionName = institution_name || ''
const projectReference = project_reference || ''
// Meta
const language = lang || 'en'
const defaultDocumentTitle = projectReference && institutionName ? `${projectReference} - ${institutionName}` : (projectReference || institutionName || '')
const metaDescription = meta_description || ''
const metaKeywords = meta_keywords || ''
const robots = envProduction ? 'index, follow' : 'noindex, noarchive, nosnippet'
// GTM
const gtmContainerId = envProduction ? gtm_container_id : false
console.log('gtmContainerId', gtmContainerId)

module.exports = {
  // Environment
  env,
  envDevelopment,
  envStaging,
  envProduction,
  // Data
  language,
  version,
  frontendUrl,
  backendUrl,
  metaDescription,
  metaKeywords,
  robots,
  twitterHandle,
  institutionUrl,
  institutionName,
  projectReference,
  defaultDocumentTitle,
  gtmContainerId
}
